import { Link } from "react-router-dom";
import { Phone, Mail, Clock } from "lucide-react";
import { BRAND } from "@/data/site";
import { useT } from "@/i18n/I18nProvider";
import { useSite } from "@/i18n/useSite";

export const Footer = () => {
  const t = useT();
  const { NAV, SERVICES, BRAND: brand } = useSite();
  return (
    <footer className="bg-[var(--blue-deep)] text-white" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src={BRAND.logo} alt={BRAND.name} className="h-14 w-auto brightness-0 invert" />
          <p className="mt-6 text-white/80 leading-relaxed max-w-md">{brand.subtitle}</p>
          <ul className="mt-8 space-y-3 text-sm">
            <li><a href={`tel:${BRAND.phone.tel}`} data-testid="footer-phone" className="inline-flex items-center gap-3 hover:text-[var(--sun)] transition-colors"><Phone size={16} className="text-[var(--coral)]" />{BRAND.phone.number}</a></li>
            <li><a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="inline-flex items-center gap-3 hover:text-[var(--sun)] transition-colors"><Mail size={16} className="text-[var(--coral)]" />{BRAND.email}</a></li>
            <li className="inline-flex items-center gap-3 text-white/80"><Clock size={16} className="text-[var(--coral)]" />{brand.hours}</li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h4 className="!text-white text-base font-semibold">{t("Explore")}</h4>
          <ul className="mt-5 space-y-2.5 text-sm">
            {NAV.filter((n) => n.to !== "/").map((n) => <li key={n.to}><Link to={n.to} className="text-white/80 hover:text-[var(--sun)] transition-colors">{n.label}</Link></li>)}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <h4 className="!text-white text-base font-semibold">{t("Services")}</h4>
          <ul className="mt-5 space-y-2.5 text-sm">
            {SERVICES.map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-white/80 hover:text-[var(--sun)] transition-colors">{s.title}</Link></li>)}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="container-x py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/60">
          <p>© {new Date().getFullYear()} {BRAND.name}. {t("All rights reserved.")}</p>
          <p className="max-w-xl">{t("We acknowledge the Traditional Custodians of the lands on which we work and live, and pay our respects to Elders past and present.")}</p>
        </div>
      </div>
    </footer>
  );
};
